import { render, staticRenderFns } from "./LegInformation.vue?vue&type=template&id=9329ddae&scoped=true"
import script from "./LegInformation.vue?vue&type=script&lang=js"
export * from "./LegInformation.vue?vue&type=script&lang=js"
import style0 from "./LegInformation.vue?vue&type=style&index=0&id=9329ddae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9329ddae",
  null
  
)

export default component.exports